module.exports = __webpack_public_path__ + "fonts/joszaki.293c6d6.woff2";